/* eslint-disable react-refresh/only-export-components -- the page-header provider component and its usePageHeader hook are intentionally colocated. */
import { createContext } from 'preact'
import { useContext, useMemo, useState } from 'preact/hooks'
import type { ComponentChildren } from 'preact'

export type BreadcrumbItem = { text: string; href?: string }

type HeaderState = {
  items: BreadcrumbItem[]
  actions?: ComponentChildren
}

type Ctx = {
  header: HeaderState
  setHeader: (state: HeaderState) => void
  clearHeader: () => void
}

const PageHeaderContext = createContext<Ctx | undefined>(undefined)

export function PageHeaderProvider({ children }: { children: ComponentChildren }) {
  const [header, setHeaderState] = useState<HeaderState>({ items: [] })
  const value = useMemo<Ctx>(() => ({
    header,
    setHeader: (state) => setHeaderState(state),
    clearHeader: () => setHeaderState({ items: [] })
  }), [header])
  return (
    <PageHeaderContext.Provider value={value}>{children}</PageHeaderContext.Provider>
  )
}

export function usePageHeader() {
  const ctx = useContext(PageHeaderContext)
  if (!ctx) throw new Error('usePageHeader must be used within a PageHeaderProvider')
  return ctx
}
